import React, {useContext, useState, useEffect, useCallback} from "react";
import {Row, Col, Upload, Modal} from "antd";
import {PlusOutlined, DownloadOutlined} from "@ant-design/icons";
import {useTranslation} from "react-i18next";
import {CreateDeliveryContext} from "../../../CreateDeliveryRequest";
import {StyledButton} from "./UpdateExcelFromTemplate.styles";
import {CustomButton} from "../../../../_defaultComponents/CustomButton/CustomButton";

export const UploadExcelFromTemplate = () => {
    const {t} = useTranslation(["newRequest"]);

    const {handleExcelUpload, isFromCustomerTheme, setOpenUploadModalFn} = useContext(
        CreateDeliveryContext
    );
    const [isModalOpen, setIsModalOpen] = useState(false);

    const showModal = useCallback(() => {
        setIsModalOpen(true);
    }, []);

    useEffect(() => {
        if (setOpenUploadModalFn) {
            setOpenUploadModalFn(() => showModal);
        }
    }, [setOpenUploadModalFn, showModal]);

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            {" "}
            <Modal
                visible={isModalOpen}
                centered
                okText={"Tamam"}
                cancelText={"İptal"}
                title="Dosya Yükleme"
                onOk={handleOk}
                onCancel={handleCancel}
                footer={null}
                style={{textAlign: "center"}}
                className={isFromCustomerTheme ? "upload-excel-modal" : ""}
            >
                <Row>
                    <Col span={24} style={{textAlign: "center"}}>
                        <h2>Yüklemek istediğiniz dosyayı seçin:</h2>
                    </Col>
                    <Col span={24} style={{textAlign: "center"}}>
                        <Upload
                            beforeUpload={() => false}
                            accept=".xlsx,.xls,.csv,.tsv"
                            onChange={async info => {
                                if (!info.fileList.length) return false;
                                handleCancel(); // Önce upload modalını kapat
                                await handleExcelUpload(info.file.originFileObj); // Sonra excel işle
                            }}
                        >
                            <StyledButton data-testid="uploadButton" icon={<PlusOutlined />}>
                                Toplu Sipariş Yükle
                            </StyledButton>
                        </Upload>
                    </Col>
                    <Col span={24} style={{marginTop: "40px"}}>
                        <CustomButton
                            href={`${process.env.PUBLIC_URL}/import-templates/toplu-siparis-yukleme-sablonu.xlsx`}
                            type="ghost"
                            icon={<DownloadOutlined />}
                            data-testid="downloadExcelTemplete"
                        >
                            {t("companyDetail.actions.downloadExcelTemplate", {
                                ns: "companyDetail"
                            })}
                        </CustomButton>
                    </Col>
                </Row>
            </Modal>
            <Row data-testid="deliveryPointCard" style={{width: "100%"}}>
                <Col span={24} style={{textAlign: "right"}}>
                    <StyledButton
                        data-testid="uploadButton"
                        icon={<PlusOutlined />}
                        onClick={showModal}
                    >
                        Toplu Sipariş Yükle
                    </StyledButton>
                </Col>
            </Row>
        </>
    );
};
